import { ExternalLink } from 'lucide-react';
import type { ToolExecutionLog } from '@/services';
import { sentinelTicketPath } from '@/lib/landing';

/** A call's conversation id, linked to its Sentinel ticket when it had one, else its helpdesk ticket. */
export const ConversationTicketLink = ({ log }: { log: ToolExecutionLog }) => {
	if (log.conversationId == null) return <span>—</span>;
	const href = log.sentinelTicketId != null ? sentinelTicketPath(log.sentinelTicketId) : log.ticketUrl;
	if (!href) return <span>{log.conversationId}</span>;
	return (
		<a
			href={href}
			target='_blank'
			rel='noreferrer'
			// Inside a table row, a click on the link must not also open the row.
			onClick={(event) => event.stopPropagation()}
			className='inline-flex items-center gap-1 hover:underline'
		>
			{log.conversationId}
			<ExternalLink className='size-3' />
		</a>
	);
};
